import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  return <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'}`} data-id="element-86" data-mp="vs79b4lt0x3n">
      <div className="container mx-auto px-4 lg:px-8" data-id="element-87" data-mp="39toq6phb7mi">
        <div className="flex justify-between items-center" data-id="element-88" data-mp="388qa601n4jd">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-89" data-mp="3ugctp58mw3cw">
            <a href="#" className="flex items-center" data-id="element-90" data-mp="6vyd3ig9j69i">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iJtC9QLhXWZPi7KGSWTJDn/Swastik_Infra_%284%29.png" alt="Swastik Infra Developers Logo" className="h-12 w-auto" data-id="element-91" data-mp="6vewq669gpxl" />
            </a>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-92" data-mp="lmnqmrh74xgj">
            <a href="#home" className="text-sm font-medium text-gray-800 hover:text-blue-700" data-id="element-93" data-mp="3k3i9eisavxpd">
              Home
            </a>
            <a href="#about" className="text-sm font-medium text-gray-800 hover:text-blue-700" data-id="element-94" data-mp="3tzv2beg0u7j2">
              About Us
            </a>
            <a href="#projects" className="text-sm font-medium text-gray-800 hover:text-blue-700" data-id="element-95" data-mp="19a5qlaam71ul">
              Projects
            </a>
            <a href="#careers" className="text-sm font-medium text-gray-800 hover:text-blue-700" data-id="element-96" data-mp="1ddty5sz8xxfu">
              Careers
            </a>
            <a href="#contact" className="text-sm font-medium text-gray-800 hover:text-blue-700" data-id="element-97" data-mp="35csauy9ixjhx">
              Contact Us
            </a>
            <a href="#contact" className="ml-4 px-5 py-2 bg-blue-800 hover:bg-blue-900 text-white rounded text-sm font-medium transition-all" data-id="element-98" data-mp="3ef1jfil8f2so">
              Schedule a Site Visit
            </a>
          </nav>
          {/* Contact Number - Desktop */}
          <div className="hidden lg:flex items-center" data-id="element-99" data-mp="30egyogvrawwj">
            <PhoneIcon className="h-4 w-4 text-blue-800 mr-2" data-id="element-100" data-mp="30g1xiip3t207" />
            <span className="text-sm font-medium" data-id="element-101" data-mp="2vlxnfqkjkduw">+91 9823446128</span>
          </div>
          {/* Mobile Menu Button */}
          <div className="lg:hidden" data-id="element-102" data-mp="27vtinfvma82b">
            <button onClick={toggleMobileMenu} className="p-2 rounded-md text-gray-700 hover:text-blue-800 focus:outline-none" data-id="element-103" data-mp="22zcyewrjgdui">
              {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-104" data-mp="n7r4sdy5xapb" /> : <MenuIcon className="h-6 w-6" data-id="element-105" data-mp="n9bxdy0x2jkj" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="lg:hidden bg-white shadow-lg" data-id="element-106" data-mp="effjf6hwodg7">
          <div className="px-4 pt-2 pb-4 space-y-3" data-id="element-107" data-mp="124i82yayj6k7">
            <a href="#home" className="block py-2 text-base font-medium text-gray-800 hover:text-blue-700" data-id="element-108" data-mp="122xbz48zvfk8">
              Home
            </a>
            <a href="#about" className="block py-2 text-base font-medium text-gray-800 hover:text-blue-700" data-id="element-109" data-mp="s6c8wogjcej1">
              About Us
            </a>
            <a href="#projects" className="block py-2 text-base font-medium text-gray-800 hover:text-blue-700" data-id="element-110" data-mp="3cv8bxm3fakmq">
              Projects
            </a>
            <a href="#careers" className="block py-2 text-base font-medium text-gray-800 hover:text-blue-700" data-id="element-111" data-mp="10yeajweb55b">
              Careers
            </a>
            <a href="#contact" className="block py-2 text-base font-medium text-gray-800 hover:text-blue-700" data-id="element-112" data-mp="3oe0ssbajcin2">
              Contact Us
            </a>
            <div className="pt-2" data-id="element-113" data-mp="jxzpimgjm1hp">
              <a href="#contact" className="block w-full text-center px-5 py-3 bg-blue-800 hover:bg-blue-900 text-white rounded text-base font-medium transition-all" data-id="element-114" data-mp="jwwxucbebv0q">
                Schedule a Site Visit
              </a>
            </div>
            <div className="flex items-center pt-2" data-id="element-115" data-mp="5yqb9sbwdhgd">
              <PhoneIcon className="h-4 w-4 text-blue-800 mr-2" data-id="element-116" data-mp="2vp3c2clz2twf" />
              <span className="text-sm font-medium" data-id="element-117" data-mp="2vm7ckjuh7x5v">+91 9823446128</span>
            </div>
          </div>
        </div>}
    </header>;
};
export default Header;